export const breadcumbMapper: Record<string, string> = {
  inspection_checklists: 'Checklists',
  inspection_items: 'Audit Items',
  physical_items: 'Physical Verification Items',
  components: 'Asset Components',
}
